module.exports = __webpack_public_path__ + "img/4.034e2797.png";